function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 17.005H11V19.005H5C2.24 19.005 0 16.765 0 14.005V5.005H2V14.005C2 15.665 3.34 17.005 5 17.005ZM6.42 3.415C7.2 2.635 7.2 1.365 6.42 0.585C5.64 -0.195 4.37 -0.195 3.59 0.585C2.81 1.365 2.81 2.635 3.59 3.415C4.37 4.205 5.63 4.205 6.42 3.415ZM7.5 7.005C7.5 5.905 6.6 5.005 5.5 5.005H5C3.9 5.005 3 5.905 3 7.005V13.005C3 14.665 4.34 16.005 6 16.005H11.07L14.57 19.505L16 18.075L10.93 13.005H7.5V7.005Z",
  fill: "#DB0001"
});

function SvgDashboardSeatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSeatIcon);
export default __webpack_public_path__ + "static/media/dashboard_SeatIcon.045f9091.svg";
export { ForwardRef as ReactComponent };